import React, { useState, useRef, useEffect } from "react";
import icons from "../../../assets/images/constantIcons";
import useAddCustomer from "./useAddCustomer";
import Table from "../../Common/Table";
import AddCustomerForm from "./AddCustomerForm";
import Pagination from "../../Common/Pagination";
import images from "../../../assets/images/constantImages";
import { useLocation } from "react-router-dom";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import toast from "react-hot-toast";

const AddCustomer = () => {
  const location = useLocation();
  const playerId = location?.state;
  const {
    columns,
    currentRows,
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    fetchCustomers,
    setFilterType,
    filterType,
    searchQuery,
    setSearchQuery,
    loading
  } = useAddCustomer(location.state, playerId);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const menuRef = useRef(null);

  const openDropdown = () => setDropdownOpen(!dropdownOpen);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // handle filtering tables by active/deactive
  const handleFilterChange = (type) => {
    setFilterType(type);
    setDropdownOpen(false);
  };

  const fileInputRef = useRef(null);

  // Function to trigger file input click
  const handleBulkUploadClick = () => {
    fileInputRef.current.click();
  };

  // Function to handle file upload
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await apiService.post("/customer_users/import_csv", formData);
      console.log(response, "response");
      if (response.status === 201) {
        toast.success(response.message, { duration: 2000 });
        fetchCustomers();
      }
    } catch (errors) {
      toast.error(errors.response.data.message, { duration: 2000 });

      // handleError(errors)
    }
  };

  // Close the filter when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex flex-col">
      <h1 className="main_heading text-2xl xl:text-[30px] mb-3">Players</h1>

      <div className="flex items-center justify-between gap-4">
        <button
          className="bg-buttoncolor text-white font-medium text-sm xl:text-base py-2 px-2 rounded-lg w-[120px] md:w-[151px] text-center"
          onClick={toggleModal}
        >
          Add Players
        </button>

        <AddCustomerForm
          isOpen={isModalOpen}
          onClose={toggleModal}
          fetchCustomers={fetchCustomers}
        />

        {/* Search & Filter Section */}
        <div className="flex items-center gap-3">
          <button
            className="border border-buttoncolor text-buttoncolor text-sm font-semibold py-2 px-4 rounded-lg hover:bg-slate-400 hover:text-white"
            onClick={handleBulkUploadClick}
          >
            Bulk Upload
          </button>

          {/* Hidden file input */}
          <input
            type="file"
            accept=".csv"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {/* Search Bar */}
          <div className="flex items-center border border-gray-300 bg-white px-3 py-2 rounded-lg w-full max-w-[250px]">
            <icons.GoSearch className="text-gray-500 mr-2" />
            <input
              name="search"
              type="text"
              placeholder="Search id, player, location"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full outline-none bg-transparent text-gray-700 placeholder-gray-400 placeholder:text-xs"
            />
          </div>

          {/* Filter Button */}
          <div className="relative" ref={menuRef}>
            <button
              onClick={openDropdown}
              className="bg-green700 w-10 h-10 flex items-center justify-center rounded-lg"
            >
              <img
                src={images.dashboardsetttingicon}
                alt="Filter"
                className="w-5 h-5"
              />
            </button>

            {/* Dropdown Menu */}
            {dropdownOpen && (
              <div className="absolute top-12 right-0 bg-white shadow-md w-[200px] px-4 py-2 z-40 text-gray-700 rounded-2xl">
                <div className="flex justify-between items-center border-b border-gray-200 py-1 mb-2">
                  <p className="text-base font-medium">Filter</p>
                  <div
                    className="bg-green50 rounded-full p-2 cursor-pointer w-8 h-8 flex items-center justify-center"
                    onClick={openDropdown}
                  >
                    <icons.IoClose className="text-green700" />
                  </div>
                </div>
                <p
                  className={`text-sm text-G500 hover:bg-green50 py-2 px-4 rounded-md cursor-pointer ${filterType === "true" ? "font-semibold text-green" : ""
                    }`}
                  onClick={() => {
                    handleFilterChange("true")
                  }}
                >
                  Active
                </p>
                <p
                  className={`text-sm text-G500 hover:bg-green50 py-2 px-4 rounded-md cursor-pointer ${filterType === "false" ? "font-semibold  text-green" : ""
                    }`}
                  onClick={() => {
                    handleFilterChange("false")
                  }}
                >
                  Deactive
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {loading ? (
        <div className="flex justify-center items-center my-4">
          <p className="text-green700 font-medium">Loading data...</p>
        </div>
      ) : (
        <div className="my-2 mb-6 overflow-auto horizontalscroll">
          <Table columns={columns} data={currentRows} />
        </div>
      )}
      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={[50, 75, 100]}
      />
    </div>
  );
};

export default AddCustomer;
